import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, DateDecoder, EnumDecoder, field, IntegerDecoder, MapDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
import { CustomerCategory, CustomerCategoryOld } from './CustomerCategory';
import { Image } from './files/Image';
import { Language, TranslatedString, TranslatedStringDecoder, TranslatedStringPatch } from './Language';
export class PromotionButton extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.text = new TranslatedString({});
        this.url = new TranslatedString({});
    }
}
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        }
    })
], PromotionButton.prototype, "text", void 0);
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        }
    })
], PromotionButton.prototype, "url", void 0);
export class Notification extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.date = new Date;
        this.didSend = false;
        this.title = new TranslatedString({});
        this.description = new TranslatedString({});
        this.ifNotRead = true;
    }
    usedNotificationTitle(promotion) {
        // Construct the default and merge with the overrides
        return promotion.title.append(": ").append(promotion.promotionText).merge(this.title);
    }
    usedNotificationDescription(promotion) {
        return promotion.subtitle.merge(this.description);
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Notification.prototype, "id", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Notification.prototype, "date", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], Notification.prototype, "didSend", void 0);
__decorate([
    field({ decoder: TranslatedStringDecoder })
], Notification.prototype, "title", void 0);
__decorate([
    field({ decoder: TranslatedStringDecoder })
], Notification.prototype, "description", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 25 })
], Notification.prototype, "ifNotRead", void 0);
export class PromotionSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.title = new TranslatedString({});
        this.subtitle = new TranslatedString({});
        this.promotionText = new TranslatedString({});
        this.promotionSubtext = new TranslatedString({});
        this.promotionSubtextStrikethrough = false;
        this.description = new TranslatedString({});
        this.categories = [];
        this.enableOrders = true;
        this.canBeCombined = false;
        this.internalDescription = "";
        this.requireDeliveryAddress = false;
        this.minimumAmount = null;
        this.maximumAmount = null;
        this.totalAmount = null;
        this.button = null;
        this.containImage = false;
        this.image = new Map();
        /**
         * @deprecated
         */
        this.notificationTitle = new TranslatedString({});
        /**
         * @deprecated
         */
        this.notificationDescription = new TranslatedString({});
        this.number = "";
        this.notifications = [];
    }
    getImageForLanguage(language) {
        // Try requested language first
        let image = this.image.get(language);
        if (image) {
            return image;
        }
        // Fall back to Dutch if available
        image = this.image.get(Language.nl);
        if (image) {
            return image;
        }
        // Fall back to first available image
        const firstImage = this.image.values().next().value;
        return firstImage !== null && firstImage !== void 0 ? firstImage : null;
    }
}
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str,
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "title", void 0);
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str,
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "subtitle", void 0);
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str,
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "promotionText", void 0);
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str,
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "promotionSubtext", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 2 })
], PromotionSettings.prototype, "promotionSubtextStrikethrough", void 0);
__decorate([
    field({ decoder: StringDecoder }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str,
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "description", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(new EnumDecoder(CustomerCategoryOld)) }),
    field({
        decoder: new ArrayDecoder(new EnumDecoder(CustomerCategory)),
        version: 20,
        upgrade: (o) => {
            return o.flatMap((c) => {
                if (Object.values(CustomerCategory).includes(c)) {
                    return [c];
                }
                console.warn("Still found an old category: " + c);
                return [];
            });
        },
    })
], PromotionSettings.prototype, "categories", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 3 })
], PromotionSettings.prototype, "enableOrders", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true, version: 25 })
], PromotionSettings.prototype, "canBeCombined", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, version: 25 })
], PromotionSettings.prototype, "internalDescription", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true, version: 25 })
], PromotionSettings.prototype, "requireDeliveryAddress", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 3, nullable: true }) // product amount per order
], PromotionSettings.prototype, "minimumAmount", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 3, nullable: true }) // product amount per client
], PromotionSettings.prototype, "maximumAmount", void 0);
__decorate([
    field({
        decoder: IntegerDecoder,
        optional: true,
        version: 25,
        nullable: true,
    }) // total product amount per promotion
], PromotionSettings.prototype, "totalAmount", void 0);
__decorate([
    field({ decoder: PromotionButton, version: 3, nullable: true })
], PromotionSettings.prototype, "button", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 3, field: "containPicture" }),
    field({ decoder: BooleanDecoder, version: 4 })
], PromotionSettings.prototype, "containImage", void 0);
__decorate([
    field({ decoder: Image, nullable: true, version: 4 }),
    field({
        decoder: new MapDecoder(StringDecoder, Image),
        version: 26,
        upgrade: (oldImage) => {
            const map = new Map();
            if (oldImage) {
                // Migrate old image to all languages
                Object.values(Language).forEach((lang) => {
                    map.set(lang, oldImage);
                });
            }
            return map;
        },
        downgrade: (images) => {
            var _a, _b;
            // Try Dutch first, then fall back to first available image
            return (_b = (_a = images.get(Language.nl)) !== null && _a !== void 0 ? _a : images.values().next().value) !== null && _b !== void 0 ? _b : null;
        }
    })
], PromotionSettings.prototype, "image", void 0);
__decorate([
    field({
        decoder: StringDecoder,
        nullable: true,
        version: 10,
        upgrade: () => null,
    }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str !== null && str !== void 0 ? str : "",
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "notificationTitle", void 0);
__decorate([
    field({
        decoder: StringDecoder,
        nullable: true,
        version: 10,
        upgrade: () => null,
    }),
    field({
        decoder: TranslatedStringDecoder,
        version: 12,
        upgrade: (str) => {
            if (str !== null && typeof str !== "string") {
                throw new Error(str);
            }
            return new TranslatedString({
                // Migrate old string values to Dutch
                [Language.nl]: str !== null && str !== void 0 ? str : "",
            });
        },
        downgrade: (name) => {
            return name.get(Language.nl);
        },
        upgradePatch: (str) => {
            if (!str) {
                return new TranslatedStringPatch({});
            }
            return new TranslatedStringPatch({ [Language.nl]: str });
        },
        downgradePatch: (name) => {
            var _a;
            if (name.translations[Language.nl]) {
                return (_a = name.translations[Language.nl]) !== null && _a !== void 0 ? _a : "";
            }
            return undefined;
        },
    })
], PromotionSettings.prototype, "notificationDescription", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 19 })
], PromotionSettings.prototype, "number", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Notification), version: 24 })
], PromotionSettings.prototype, "notifications", void 0);
export var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["Disabled"] = "Disabled";
    PromotionStatus["Active"] = "Active";
    PromotionStatus["Testing"] = "Testing";
})(PromotionStatus || (PromotionStatus = {}));
export class PromotionStatusHelper {
    static getName(category, i18n) {
        switch (category) {
            case PromotionStatus.Disabled: return i18n.t('status.disabled');
            case PromotionStatus.Active: return i18n.t('status.active');
            case PromotionStatus.Testing: return i18n.t('status.testing');
        }
    }
}
export class Promotion extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = PromotionSettings.create({});
        this.wholesalerOverrides = new Map();
        this.excludeWholesalers = [];
        this.wholesalerId = null;
        this.startAt = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 10, 0, 0);
        this.endAt = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0);
        /**
         * Date of the next notification (if any)
         */
        this.notificationAt = null;
        /**
         * @deprecated
         */
        this.didSendNotification = false;
        this.status = PromotionStatus.Active;
    }
    getSettingsFor(wholesalerId = null) {
        if (!wholesalerId) {
            return this.settings;
        }
        const overrides = this.wholesalerOverrides.get(wholesalerId);
        if (overrides) {
            return this.settings.patch(overrides);
        }
        return this.settings;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Promotion.prototype, "id", void 0);
__decorate([
    field({ decoder: PromotionSettings })
], Promotion.prototype, "settings", void 0);
__decorate([
    field({
        decoder: new MapDecoder(StringDecoder, PromotionSettings.patchType()),
        version: 18,
    })
], Promotion.prototype, "wholesalerOverrides", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), optional: true })
], Promotion.prototype, "excludeWholesalers", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Promotion.prototype, "wholesalerId", void 0);
__decorate([
    field({ decoder: DateDecoder })
    // default value: today at 10:00
], Promotion.prototype, "startAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
    // default value: today at 23:59
], Promotion.prototype, "endAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Promotion.prototype, "notificationAt", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], Promotion.prototype, "didSendNotification", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PromotionStatus), version: 21 })
], Promotion.prototype, "status", void 0);
//# sourceMappingURL=Promotion.js.map